// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5FJ1c","badges":"styles_badges__3HKHT"};